import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogCreateUpdateDeleteComponent } from '../views/genericos/dialog-create-update-delete/dialog-create-update-delete.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { DialogDeleteComponent } from '../views/genericos/dialog-delete/dialog-delete.component';
import { GenericDialogComponent } from '../views/genericos/generic-dialog/generic-dialog.component';
import { ConfirmationModalComponent } from '../component/confirmation-modal/confirmation-modal.component';
import { DeleteConfirmationModalComponent } from '../component/delete-confirmation-modal/delete-confirmation-modal.component';



@NgModule({
  declarations: [
    DialogCreateUpdateDeleteComponent,
    DialogDeleteComponent,
    GenericDialogComponent,
    ConfirmationModalComponent,
    DeleteConfirmationModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports:[
    DialogCreateUpdateDeleteComponent,
    DialogDeleteComponent,
    GenericDialogComponent,
    ConfirmationModalComponent,
    DeleteConfirmationModalComponent
  ]
})
export class GenericosModule { }
